export const ArticleColumnsEN = [
  {
    key: 'Id',
    name: 'ID',
    editable: false,
    filterable: true,
    sortable: true,
    width: 80
  },
  {
    key: 'Line1',
    name: 'Lat. Name',
    editable: false,
    filterable: true,
    sortable: true,
  },
  {
    key: 'Line2',
    name: 'Name',
    editable: false,
    filterable: true,
    sortable: true,
  },
  {
    key: 'PetType',
    name: 'Pet Type',
    editable: false,
    filterable: true,
    sortable: true,
  },
  {
    key: 'CustomerName',
    name: 'Integration Name',
    editable: true,
    filterable: true,
    sortable: true,
    width: 150
  },
  {
    key: 'Price',
    name: 'Price',
    editable: true,
    filterable: true,
    sortable: true,
    width: 80
  },
  {
    key: 'Barcode',
    name: 'EAN',
    editable: true,
    filterable: true,
    sortable: true,
    width: 100
  },
  {
    key: 'PLUCode',
    name: 'PLU',
    editable: true,
    filterable: true,
    sortable: true,
    width: 80
  }
];

export const ArticleColumnsDE = [
  {
    key: 'Id',
    name: 'ID',
    editable: false,
    filterable: true,
    sortable: true,
    width: 80
  },
  {
    key: 'Line1',
    name: 'Lat. Name',
    editable: false,
    filterable: true,
    sortable: true,
  },
  {
    key: 'Line2',
    name: 'Name',
    editable: false,
    filterable: true,
    sortable: true,
  },
  {
    key: 'PetType',
    name: 'Tiertyp',
    editable: false,
    filterable: true,
    sortable: true,
  },
  {
    key: 'CustomerName',
    name: 'Integrationsname',
    editable: true,
    filterable: true,
    sortable: true,
    width: 150
  },
  {
    key: 'Price',
    name: 'Preis',
    editable: true,
    filterable: true,
    sortable: true,
    width: 80
  },
  {
    key: 'Barcode',
    name: 'EAN',
    editable: true,
    filterable: true,
    sortable: true,
    width: 100
  },
  {
    key: 'PLUCode',
    name: 'PLU',
    editable: true,
    filterable: true,
    sortable: true,
    width: 80
  }
];


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/ArticleColumns.js
 **/